import "./userOrderProductRow.css"

export function UserOrderProductRow({ product }) {
    return (
        <table className="user-order-products-table my-2 ps-4">
            <tbody>
                <tr className="">
                    <td className="ps-4 prdct-td">
                        <div className="d-flex align-items-center prduct-row-img-section gap-3">
                            <img src={product.image} width={30} alt="" />
                            <div className="usr-ordr-prdct-title">{product.title}</div>
                        </div>
                    </td>
                    <td>{product.quantity}</td>
                    <td>${product.salePrice ? product.salePrice : product.regularPrice}</td>
                </tr>
            </tbody>
        </table>
    )
}